export enum Pathname {
  AcceptPayments = 'payments',
  AcceptPaymentsPaymentsDashboard = 'payments/overview',
}
